// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import "./index.css";
import { ToastContainer } from 'react-toastify';
import "./i18n";

// Set up global axios defaults to include credentials with all requests
axios.defaults.baseURL =
  process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === "production" ? "" : "http://localhost:5001");
axios.defaults.withCredentials = true; // This ensures cookies are sent with requests

// Add an interceptor for authorization
axios.interceptors.request.use(
  (config) => {
    // The JWT token is automatically included in HTTP-only cookies
    // when withCredentials is true, so we don't need to manually add it

    // However, we can add the refresh token if needed for specific endpoints
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken && config.url === "/api/auth/refresh") {
      // Only include the refresh token for token refresh requests
      config.data = { ...config.data, refreshToken };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If the error is due to an expired token (401) and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
          await axios.post("/api/auth/refresh", { refreshToken });
          // After successful token refresh, retry the original request
          return axios(originalRequest);
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
      }
    }

    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer
      theme="dark"
      hideProgressBar={true}
      position="top-center"
    />
  </React.StrictMode>
);
